import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { size } from '@twisto/styles'

export const tableOfContentLabel = css`
  margin-bottom: ${size[16]};
`

export const tableOfContentList = css`
  padding: 0;
  padding-left: ${size[24]};
  margin: 0;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${size[8]};
`

export const tableOfContentListItem = (theme: Theme) => css`
  margin: 0;
  list-style-type: disc;

  &::marker {
    color: ${theme.palette.additionalColor.purple[500]};
  }
`

export const tableOfContentListItemPadded = css`
  margin-left: ${size[16]};
`
